import axios from "axios";

let id_token = localStorage.getItem('id_token')

const axiosLink = axios.create({
    baseURL: "https://t7r.ir/api",
    timeout: 150000,
    headers: {
        Authorization: id_token ? `Bearer ${id_token}` : undefined,
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

function header() {
    return id_token ? {

        Authorization: `Bearer ${id_token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
    } : {
        Accept: "application/json",
        "Content-Type": "application/json",
    };
}

function geturl(uri) {
    return `https://t7r.ir/${uri}`;
}
function GetLinks(queries = {}) {
    return new Promise((resolve, reject) => {
        axios.get(geturl("api/link"), {
            headers: header(),
            params: queries,
        })
        .then(({data}) => {
            if (data && Array.isArray(data.data)) {
                const filteredData = data.data.map(item => ({
                    id: item.id,
                    shortUrl: `${item.domains.domain}/${item.code}`,
                    longUrl: item.link,
                    create_at: item.created_at,
                    domin: item.domains.domain,
                    title: item.title || "",
                    id_user: item?.user_id,
                    active: item.active ?? true,
                    views: item.viewsC ?? 0,
                    ended_at: item.ended_at ?? null,
                    updated_at: item.updated_at ?? null
                }));

                resolve(filteredData);
            } else {
                console.error("داده دریافت شده معتبر نیست:", data);
                resolve([]);
            }
        })
        .catch(({response}) => {
            console.error("خطا دردریافت از سرور:", response);
            reject(response);
        });
    });
}
function GetLinkById(id,queries = {}) {
    return new Promise((resolve,reject)=>{
        axios.get(geturl(`api/link/show/${id}`), {
            headers: header(),
            params: queries,
        }).then(({data}) =>{   
        if (data && Array.isArray(data.data)) {
            const filteredData = data.data.map(item => ({
                id: item.id,
                shortUrl: `${item.domains.domain}/${item.code}`,
                longUrl: item.link,
                create_at: item.create_at,
                domin: item.domains.domain,
                title: item.title || "",
                id_user: item?.user_id,
                active: item.active || true,
                views: item.viewsC || 0,
                ended_at: item.ended_at || null,
                updated_at: item.updated_at || null
            }));
            resolve(filteredData);
        } else {
            console.error("داده دریافت شده از سرور معتبر نیست:", data);
            resolve([]); 
        }
    }).catch(({response})=>{
        console.error("خطا در دریافت از سرور:", response);
        reject(response);
    });
});

}

function AddLink(data = {}) {
    return new Promise((resolve,reject)=>{
        axiosLink.post(geturl("api/add/link"), data, {
            headers: header(),
        }).then(({data})=>{
            resolve(data); 
            }).catch(({response})=>{
            console.error("خطا در دریافت از سرور:", response);
            reject(response);
        })
    })
}
 function AddMultilink(data = {}) {
    return new Promise((resolve,reject)=>{
        axiosLink.post(geturl("api/add/link/group"), data, {
            headers: header(),
        }).then(({data})=>{
            resolve(data); 
            }).catch(({response})=>{
            console.error("خطا در دریافت از سرور:", response);
            reject(response);
        })
    })
}

function EditLink(id, data = {}, queries = {}) {
    return new Promise((resolve,reject)=>{
        axiosLink.post(geturl(`api/update/link/${id}`), data, {
            headers: header(),
            params: queries,
        }).then(({data})=>{
            resolve(data); 
            }).catch(({response})=>{
            console.error("خطا در دریافت از سرور:", response);
            reject(response);
        })
    })
}

function DeleteLink(id,queries = {}) {
    return new Promise((resolve,reject)=>{
        axiosLink.delete(geturl(`api/link/delete/${id}`), {
            headers: header(),
            params: queries,
        }).then(({data})=>{
            resolve(data); 
            }).catch(({response})=>{
            console.error("خطا در دریافت از سرور:", response);
            reject(response);
        })
    })
}
function GetDomain(queries = {}) {
    return new Promise((resolve, reject) => {
        axiosLink.get(geturl("api/domain/show"), { params: queries })
            .then(({ data }) => {
                if (data && Array.isArray(data.domains)) {
                    resolve(data.domains);
                } else {
                    console.error("داده دریافت شده از سرور معتبر نیست:", data);
                    resolve([]);
                }
            })
            .catch(err => {
                console.error("خطا در دریافت داده از سرور:", err);
                reject(err);
            });
    });
}
export {
    GetDomain,
    GetLinks,
    DeleteLink,
    AddLink,
    EditLink,
    AddMultilink,
    GetLinkById
};